import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from '@hostfully/ui-components';
import {
  ButtonContainer,
  RegisterSubtitle,
  RegisterTitle,
} from './Register.styles';

const RegisterErrorState = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div data-testid="register-error">
      <RegisterTitle data-testid="register-error-title">
        {t('pageRegister.errorTitle')}
      </RegisterTitle>
      <RegisterSubtitle data-testid="register-error-subtitle">
        {t('pageRegister.errorMessage')}
      </RegisterSubtitle>
      <ButtonContainer>
        <Button
          data-testid="error-go-to-login"
          variant="textPrimary"
          onClick={() => navigate('/login')}
        >
          {t('pageRegister.goToLogin')}
        </Button>
      </ButtonContainer>
    </div>
  );
};

export default RegisterErrorState;
